<mat-card class="card">
  <mat-card-header>
    <mat-card-title>rooms</mat-card-title>
  </mat-card-header>
  <mat-card-actions>
    <button mat-raised-button color="accent" (click)="loadRooms()" class="action-btn">refresh</button>
  </mat-card-actions>
</mat-card>

<mat-card *ngIf="rooms.length == 0" class="card spinner-card"
  ><mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>
</mat-card>

<mat-card *ngFor="let room of rooms" class="card">
  <mat-card-header>
    <mat-card-subtitle>{{ room.roomId }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    map: {{ room.mapId }}<br />
    joined: {{ room.roomCharacterCount }}
  </mat-card-content>
  <mat-card-actions>
    <button *ngIf="!joinedRoom" mat-raised-button color="primary" (click)="join(room)" class="action-btn">join</button>
    <button
      *ngIf="joinedRoom?.roomId === room.roomId"
      mat-raised-button
      color="warn"
      (click)="leave()"
      class="action-btn"
    >
      leave
    </button>
  </mat-card-actions>
</mat-card>
